import { type Dispatch, useContext } from "react";
import {
  ShopTypeActions,
  ShopTypeContext,
  ShopTypeDispatch,
  ShopTypeState,
} from "src/contexts/shop-type.context";

export function useShopTypeContext(): ShopTypeState {
  const shopTypeContext = useContext(ShopTypeContext);

  if (typeof shopTypeContext === "undefined") {
    throw new Error(
      "Please make sure you use useShopTypeContext inside ShopTypeContextProvider."
    );
  }

  return shopTypeContext;
}

export function useShopTypeDispatch(): Dispatch<ShopTypeActions> {
  const shopTypeDispatch = useContext(ShopTypeDispatch);

  if (!shopTypeDispatch) {
    throw new Error(
      "Please make sure you use useShopTypeDispatch inside ShopTypeContextProvider."
    );
  }

  return shopTypeDispatch;
}
